import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { Card, Icon, Typography, Spin, Button, Row, Col } from 'antd'
import { Wrapper, Center, styles } from './styles'
import axios from 'axios'
import UserRanking from './components/UserRanking'

const { Title } = Typography

export const Dashboard = ({ }) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/dashboard/all`)
      setData(result.data)
    }

    fetchData()
  }, [])

  const refetchData = async () => { }

  return (
    <div>
      <div style={styles.reloadBtnWrapper}>
        <Button
          style={styles.reloadtBtn}
          size="small"
          icon="reload"
          onClick={() => refetchData()}
        >
          Reload
        </Button>
      </div>
      <Wrapper>
        <Card style={styles.card}>
          <Card.Meta
            avatar={<Icon type="team" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.approvedHero}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Heroes
              </Title>
            }
          />
        </Card>

        <Card style={styles.card}>
          <Card.Meta
            avatar={<Icon type="user-add" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.pendingHero}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Hero Request
              </Title>
            }
          />
        </Card>

        <Card style={styles.card}>
          <Card.Meta
            avatar={<Icon type="delete" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.materialCount}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Products
              </Title>
            }
          />
        </Card>

        <Card style={styles.card}>
          <Card.Meta
            avatar={<Icon type="environment" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.locationCount}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Locations
              </Title>
            }
          />
        </Card>

        <Card style={styles.card} >
          <Card.Meta
            avatar={<Icon type="barcode" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.barcodeProductCount}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Barcode Product
              </Title>
            }
          />
        </Card>
        <Card style={styles.card} >
          <Card.Meta
            avatar={<Icon type="alert" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.activeAnnouncement}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Active Announcement
              </Title>
            }
          />
        </Card>
        <Card style={styles.card} >
          <Card.Meta
            avatar={<Icon type="notification" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.totalAnnouncement}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Total Announcement
              </Title>
            }
          />
        </Card>
        <Card style={styles.card} >
          <Card.Meta
            avatar={<Icon type="file-text" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.poActive}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Active PO
              </Title>
            }
          />
        </Card>
        <Card style={styles.card} >
          <Card.Meta
            avatar={<Icon type="file-text" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.podActive}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Active POD
              </Title>
            }
          />
        </Card>
        <Card style={styles.card} >
          <Card.Meta
            avatar={<Icon type="team" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.appUserCount}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Users
              </Title>
            }
          />
        </Card>
        <Card style={styles.card} >
          <Card.Meta
            avatar={<Icon type="file-text" style={styles.icon} />}
            title={
              <Title level={1} style={styles.description}>
                {data.billCount}
              </Title>
            }
            description={
              <Title level={4} style={styles.description}>
                Bills
              </Title>
            }
          />
        </Card>
      </Wrapper>
      <Row gutter={8}>
        <Col span={12}>
          <UserRanking />
        </Col>
        {/* <Col span={12} /> */}
      </Row>
    </div>
  )
}

Dashboard.propTypes = {
  data: PropTypes.object.isRequired
}

export default compose(withApollo)(Dashboard)
